import type { ApolloClient } from '@apollo/client/core';
import { ApolloLink, InMemoryCache } from '@apollo/client/core';
import { HttpLink } from 'apollo-angular/http';

import { environment } from '@customer-portal/environments';
import { APOLLO_CLIENT_NAMES } from '@customer-portal/shared/constants';

export const APOLLO_NAMED_CLIENTS = Object.values(APOLLO_CLIENT_NAMES);

export function getGraphqlHostForClient(name: string): string {
  if (name === APOLLO_CLIENT_NAMES.invoice) {
    return environment.invoicesGraphqlHost;
  }

  return String(
    environment[`${name}GraphqlHost` as keyof typeof environment] ?? '',
  );
}

export function createApolloNamedClientConfig(
  uri: string,
  httpLink: HttpLink,
  errorLink: ApolloLink,
): ApolloClient.Options {
  return {
    cache: new InMemoryCache(),
    link: ApolloLink.from([
      errorLink,
      httpLink.create({
        uri,
        withCredentials: true,
      }),
    ]),
    defaultOptions: {
      query: {
        errorPolicy: 'all',
      },
    },
  };
}
